import React from 'react';
import cs from 'classnames';
import Flexbox from 'flexbox-react';

export default ({ children, type, ...props }) => <button {...props} className={cs('btn', type && `btn-${type}`)}><Flexbox>{children}</Flexbox></button>


// WEBPACK FOOTER //
// ./src/components/Button/Button.js